<template>
    <div class="page">
        <h1 class="text_13 page__title">
            {{ $t("lookbook") }}
        </h1>
        <nuxt-link
            :to="{ name: 'lookbook-slug', params: { slug: item.slug } }"
            class="lookbook"
            v-for="(item, index) in lookbook"
            :key="index">
            <div class="text_13 lookbook__title">{{ item.name }}</div>
            <div class="row flex-row row--fullwidth">
                <div v-for="(image, i_index) in item.images" class="col lg-4 sm-6 col--no-padding" :key="i_index">
                    <UiImage
                        draggable="false"
                        width="100%"
                        lazy
                        alt=""
                        :path="image.path"
                        :mobile="cropSize.m"
                        :desktop="cropSize.d"></UiImage>
                </div>
            </div>
        </nuxt-link>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import UiImage from "@/components/ui/Image";
export default {
    name: "LookBookPage",
    components: { UiImage },
    async asyncData({ $axios }) {
        const lookbook = await $axios.get("/api/looks");
        return { lookbook: lookbook.data };
    },
    head() {
        return {
            title:this.$i18n.t("lookbook_title"),
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.$i18n.t("lookbook_description"),
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.$i18n.t("lookbook_description"),
                },
            ],
        };
    },

    data() {
        return {
            crumbs: [
                {
                    name: this.$i18n.t("lookbook"),
                },
            ],
            cropSize: {
                d: { width: 630, height: 950 },
                m: { width: 216, height: 324 },
            },
        };
    },
    watch: {
        async langust() {
            await this.$nuxt.refresh();
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
    },

    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
    },
};
</script>
<style lang="less" scoped>
.lookbook {
    margin-bottom: 32px;
    @media @sm {
        background: #fff;
    }
    &__title {
        height: 36px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
    }
    > .row {
        gap: 1px;
        flex-wrap: nowrap;
    }
}
</style>
